module.exports = __webpack_public_path__ + "img/error.7db2614f.jpg";